import { Link } from 'react-router-dom';

export default function ChannelShowcase() {
  return (
    <section className="py-10 md:py-14 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="mb-8">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading">特色频道</h2>
          <p className="text-sm text-foreground-600 mt-1">发现更多精彩内容频道</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          <Link
            to="/category/tesejiemu"
            className="group relative rounded-xl overflow-hidden h-48 md:h-56 cursor-pointer"
          >
            <img
              src="https://readdy.ai/api/search-image?query=Mystical%20fantasy%20realm%20with%20glowing%20fairy%20dust%20and%20magical%20auras%2C%20ethereal%20atmosphere%20with%20soft%20sparkling%20lights%2C%20dreamy%20fantasy%20art%20style%2C%20enchanting%20visual%20composition&width=600&height=400&seq=channel-fairy&orientation=landscape"
              alt="妖精视频"
              className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-600"
              loading="lazy"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-accent-500 to-accent-600 opacity-70 group-hover:opacity-80 transition-opacity duration-300"></div>
            <div className="absolute inset-0 flex flex-col items-center justify-center text-white p-4">
              <h3 className="text-xl md:text-2xl font-bold font-heading mb-1">妖精视频</h3>
              <p className="text-xs text-white/80">奇幻与魔法的视觉盛宴</p>
            </div>
          </Link>

          <Link
            to="/category/tesejiemu"
            className="group relative rounded-xl overflow-hidden h-48 md:h-56 cursor-pointer"
          >
            <img
              src="https://readdy.ai/api/search-image?query=Beautiful%20spring%20peach%20blossom%20garden%20with%20pink%20petals%20in%20full%20bloom%2C%20soft%20romantic%20sunlight%2C%20traditional%20Chinese%20aesthetic%2C%20dreamy%20pastel%20atmosphere&width=600&height=400&seq=channel-peach&orientation=landscape"
              alt="桃花视频"
              className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-600"
              loading="lazy"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-primary-500 to-primary-600 opacity-70 group-hover:opacity-80 transition-opacity duration-300"></div>
            <div className="absolute inset-0 flex flex-col items-center justify-center text-white p-4">
              <h3 className="text-xl md:text-2xl font-bold font-heading mb-1">桃花视频</h3>
              <p className="text-xs text-white/80">浪漫春日的桃花世界</p>
            </div>
          </Link>

          <Link
            to="/category/tesejiemu"
            className="group relative rounded-xl overflow-hidden h-48 md:h-56 cursor-pointer"
          >
            <img
              src="https://readdy.ai/api/search-image?query=Modern%20sleek%20tech%20showroom%20with%20holographic%20displays%20and%20futuristic%20gadgets%2C%20clean%20minimalist%20design%2C%20soft%20ambient%20lighting%2C%20contemporary%20technology%20aesthetic&width=600&height=400&seq=channel-apple&orientation=landscape"
              alt="苹果视频"
              className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-600"
              loading="lazy"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-secondary-600 to-secondary-700 opacity-70 group-hover:opacity-80 transition-opacity duration-300"></div>
            <div className="absolute inset-0 flex flex-col items-center justify-center text-white p-4">
              <h3 className="text-xl md:text-2xl font-bold font-heading mb-1">苹果视频</h3>
              <p className="text-xs text-white/80">科技与创新的前沿阵地</p>
            </div>
          </Link>

          <Link
            to="/category/tesejiemu"
            className="group relative rounded-xl overflow-hidden h-48 md:h-56 cursor-pointer"
          >
            <img
              src="https://readdy.ai/api/search-image?query=Dynamic%20extreme%20sports%20action%20with%20adrenaline-filled%20moments%2C%20dramatic%20lighting%20and%20bold%20colors%2C%20energy-packed%20composition%2C%20thrilling%20visual%20experience&width=600&height=400&seq=channel-durian&orientation=landscape"
              alt="榴莲视频"
              className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-600"
              loading="lazy"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-accent-600 to-accent-700 opacity-70 group-hover:opacity-80 transition-opacity duration-300"></div>
            <div className="absolute inset-0 flex flex-col items-center justify-center text-white p-4">
              <h3 className="text-xl md:text-2xl font-bold font-heading mb-1">榴莲视频</h3>
              <p className="text-xs text-white/80">热血与激情的极限挑战</p>
            </div>
          </Link>
        </div>
      </div>
    </section>
  );
}